import React, { useEffect, useRef, useState, useCallback } from "react";
import { useOnboardingStore } from "../../store/useOnboardingStore";
import useAuthStore from "../../store/useAuthStore";
import useSignIn from "react-auth-kit/hooks/useSignIn";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo_2.png";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import { Backdrop, CircularProgress } from "@mui/material";
import "react-circular-progressbar/dist/styles.css";
import CropperModal from "../CropperModal";

/* ═══════════════════════════════════════════════════
   INJECT STYLES — Step4 se identical
═══════════════════════════════════════════════════ */
const injectStyles = () => {
  if (document.getElementById("obp-styles")) return;
  const s = document.createElement("style");
  s.id = "obp-styles";
  s.innerHTML = `
    @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');

    @keyframes obp-shimmer { 0%{background-position:200% center} 100%{background-position:-200% center} }

    /* ── Bot keyframes — Step4 se exact same ── */
    @keyframes slideInBot {
      from { opacity:0; transform:translateY(-8px) scale(0.96); }
      to   { opacity:1; transform:translateY(0)    scale(1);    }
    }
    @keyframes botCursor { 0%,100%{opacity:1} 50%{opacity:0} }
    @keyframes speakBar  { 0%,100%{transform:scaleY(1)} 50%{transform:scaleY(1.9)} }
    @keyframes pulseDot  { 0%,100%{opacity:1} 50%{opacity:.35} }
    @keyframes botBobSvg { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-2.5px)} }
    @keyframes floatHeartL1 {
      0%  { transform:translate(0,0)         scale(1);    opacity:1; }
      100%{ transform:translate(-14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartL2 {
      0%  { transform:translate(0,0)        scale(0.82); opacity:0.9; }
      100%{ transform:translate(-4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartL3 {
      0%  { transform:translate(0,0)       scale(0.68); opacity:0.8; }
      100%{ transform:translate(9px,-50px) scale(0.22); opacity:0; }
    }
    @keyframes floatHeartR1 {
      0%  { transform:translate(0,0)        scale(1);    opacity:1; }
      100%{ transform:translate(14px,-54px) scale(0.18); opacity:0; }
    }
    @keyframes floatHeartR2 {
      0%  { transform:translate(0,0)       scale(0.82); opacity:0.9; }
      100%{ transform:translate(4px,-58px) scale(0.12); opacity:0; }
    }
    @keyframes floatHeartR3 {
      0%  { transform:translate(0,0)        scale(0.68); opacity:0.8; }
      100%{ transform:translate(-9px,-50px) scale(0.22); opacity:0; }
    }

    /* ── Bot SVG classes — Step4 se exact same ── */
    .ob-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
    .ob-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
    .ob-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
    .ob-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
    .ob-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
    .ob-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
    .ob-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }

    /* ── Bot popup wrapper — Step4 se exact same ── */
    .obp-wrap { position:fixed; z-index:99999; animation:slideInBot .28s cubic-bezier(.34,1.2,.64,1) both; }
    .obp-wrap::before { content:''; position:absolute; width:16px; height:9px; background:#c0001a; clip-path:polygon(50% 0%,100% 100%,0% 100%); }
    .obp-wrap.below::before   { top:-9px;    left:24px; }
    .obp-wrap.above::before   { bottom:-9px; left:24px; transform:rotate(180deg); }
    .obp-wrap.toright::before { top:24px;    left:-9px; transform:rotate(-90deg); }
    .obp-wrap.toleft::before  { top:24px;    right:-9px; transform:rotate(90deg); }

    /* ── Bot card — Step4 se exact same ── */
    .obp-card-popup {
      background:#fff; border-radius:14px; border:1px solid rgba(0,0,0,.07); overflow:hidden;
      box-shadow:0 4px 8px rgba(0,0,0,.06),0 18px 52px rgba(0,0,0,.18),0 2px 10px rgba(192,0,26,.1);
    }
    .obp-hd {
      background:linear-gradient(135deg,#c0001a 0%,#8b0000 58%,#5c0000 100%);
      padding:12px 14px 10px; display:flex; align-items:center; gap:10px;
      position:relative; overflow:visible;
    }
    .obp-hd::after {
      content:''; position:absolute; inset:0; pointer-events:none;
      background-image:linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),
                       linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px);
      background-size:16px 16px;
    }
    .obp-av   { position:relative; flex-shrink:0; z-index:1; overflow:visible; }
    .obp-bars { display:flex; align-items:flex-end; gap:2px; position:absolute; bottom:-3px; right:-4px; background:rgba(0,0,0,.3); border-radius:4px; padding:2px 3px; z-index:2; }
    .obp-b    { width:2.5px; border-radius:2px; background:#fff; transform-origin:bottom; }
    .obp-b:nth-child(1){ height:4px;  animation:speakBar .48s .00s ease-in-out infinite; }
    .obp-b:nth-child(2){ height:9px;  animation:speakBar .48s .10s ease-in-out infinite; }
    .obp-b:nth-child(3){ height:6px;  animation:speakBar .48s .20s ease-in-out infinite; }
    .obp-b:nth-child(4){ height:3px;  animation:speakBar .48s .30s ease-in-out infinite; }
    .obp-meta { flex:1; z-index:1; min-width:0; overflow:hidden; }
    .obp-name { font-size:11.5px; font-weight:800; color:#fff; letter-spacing:.06em; font-family:'DM Mono','Fira Code',monospace; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; }
    .obp-sub  { font-size:9.5px; color:rgba(255,255,255,.7); display:flex; align-items:center; gap:4px; margin-top:2px; }
    .obp-dot  { width:5px; height:5px; border-radius:50%; background:#6effa0; box-shadow:0 0 4px rgba(100,255,150,.85); flex-shrink:0; animation:pulseDot 2s ease-in-out infinite; }
    .obp-badge{ z-index:1; flex-shrink:0; background:rgba(255,255,255,.16); border:1px solid rgba(255,255,255,.3); border-radius:20px; padding:2px 8px; font-size:10px; font-weight:700; color:#fff; white-space:nowrap; }
    .obp-tag     { background:linear-gradient(90deg,#fff5f5,#fff); border-bottom:1px solid rgba(192,0,26,.1); padding:5px 14px; display:flex; align-items:center; gap:6px; }
    .obp-tag-dot { width:5px; height:5px; border-radius:50%; background:#c0001a; flex-shrink:0; }
    .obp-tag-txt { font-size:9.5px; font-weight:800; color:#c0001a; letter-spacing:.08em; }
    .obp-body { padding:10px 14px 8px; }
    .obp-msg  { font-size:13px; line-height:1.62; color:#1a1a1a; word-break:break-word; margin:0; }
    .obp-msg strong { color:#c0001a; font-weight:800; }
    .obp-cur  { display:inline-block; width:2px; height:13px; background:#c0001a; border-radius:2px; margin-left:2px; vertical-align:middle; animation:botCursor .65s ease-in-out infinite; }
    .obp-ft   { padding:8px 14px 11px; display:flex; align-items:center; justify-content:space-between; gap:8px; border-top:1px solid rgba(0,0,0,.05); background:#fafafa; }
    .obp-dots { display:flex; gap:4px; align-items:center; }
    .obp-d    { width:6px; height:6px; border-radius:50%; background:#e0e0e0; transition:all .3s; }
    .obp-d.on { width:18px; border-radius:999px; background:linear-gradient(90deg,#c0001a,#8b0000); }
    .obp-skip-bot { background:none; border:none; cursor:pointer; font-size:11px; color:#c0c0c0; padding:4px 6px; border-radius:6px; transition:all .18s; white-space:nowrap; }
    .obp-skip-bot:hover { background:#f0f0f0; color:#888; }
    .obp-next { background:linear-gradient(135deg,#c0001a,#8b0000); color:#fff; border:none; border-radius:8px; padding:7px 16px; font-size:12px; font-weight:800; cursor:pointer; letter-spacing:.03em; box-shadow:0 3px 12px rgba(192,0,26,.32); transition:all .18s; white-space:nowrap; }
    .obp-next:hover  { transform:translateY(-1px); box-shadow:0 5px 16px rgba(192,0,26,.46); }
    .obp-next:active { transform:scale(.97); }

    /* ── Page background — Step4 se EXACT same ── */
    .obp-section { background:#f8f5f0 !important; min-height:100vh !important; }

    /* ── Progress bars — Step4 se exact same ── */
    .obp-prog-wrap { display:flex !important; gap:5px !important; margin-top:10px !important; }
    .obp-prog-bar  { height:4px !important; border-radius:999px !important; flex:1 !important; background:#e2e8f0 !important; }
    .obp-prog-bar.done   { background:linear-gradient(90deg,#c0001a,#8b0000) !important; }
    .obp-prog-bar.active { background:linear-gradient(90deg,#e0001f,#c0001a) !important; animation:obp-shimmer 2s linear infinite !important; background-size:200% auto !important; }

    /* ── One last step badge — same style as GenresStep ── */
    .obp-almost {
      display:inline-flex !important; align-items:center !important; gap:8px !important;
      background:linear-gradient(135deg,#fff5f5,#fee2e2) !important;
      border:1.5px solid rgba(192,0,26,.25) !important; border-radius:999px !important;
      padding:7px 18px 7px 12px !important;
      font-size:12.5px !important; font-weight:700 !important; color:#c0001a !important;
      font-family:'Inter',sans-serif !important; margin-top:12px !important;
      box-shadow:0 2px 8px rgba(192,0,26,.1) !important; white-space:nowrap !important;
    }
    .obp-almost-icon {
      width:22px !important; height:22px !important; border-radius:50% !important;
      background:linear-gradient(135deg,#ef4444,#c0001a) !important;
      display:flex !important; align-items:center !important; justify-content:center !important;
      font-size:11px !important; flex-shrink:0 !important;
    }

    /* ── Photo upload boxes ── */
    .obp-photo-card {
      background:#fff !important;
      border:1.5px solid #e8e3dc !important;
      border-radius:16px !important;
      padding:22px !important;
      box-shadow:0 1px 4px rgba(0,0,0,.04) !important;
    }

    .obp-upload-main {
      width:100% !important; aspect-ratio:389/438 !important;
      border:2px dashed #d4cfc8 !important; border-radius:14px !important;
      display:flex !important; flex-direction:column !important;
      align-items:center !important; justify-content:center !important;
      cursor:pointer !important; overflow:hidden !important;
      background:#fafaf8 !important;
      transition:border-color .15s, background .15s !important;
      position:relative !important;
    }
    .obp-upload-main:hover { border-color:#c0001a !important; background:#fff5f5 !important; }
    .obp-upload-main.has-image { border-style:solid !important; border-color:#e8e3dc !important; background:#fff !important; padding:0 !important; }

    .obp-upload-sm {
      width:100% !important; aspect-ratio:1/1 !important;
      border:2px dashed #d4cfc8 !important; border-radius:12px !important;
      display:flex !important; flex-direction:column !important;
      align-items:center !important; justify-content:center !important;
      cursor:pointer !important; overflow:hidden !important;
      background:#fafaf8 !important;
      transition:border-color .15s, background .15s !important;
      position:relative !important;
    }
    .obp-upload-sm:hover { border-color:#c0001a !important; background:#fff5f5 !important; }
    .obp-upload-sm.has-image { border-style:solid !important; border-color:#e8e3dc !important; background:#fff !important; padding:0 !important; }

    .obp-upload-icon {
      width:44px !important; height:44px !important; border-radius:50% !important;
      background:linear-gradient(135deg,#fff0f0,#ffe4e4) !important;
      border:1.5px solid rgba(192,0,26,.18) !important;
      display:flex !important; align-items:center !important; justify-content:center !important;
      margin-bottom:10px !important; font-size:18px !important; color:#c0001a !important;
    }
    .obp-upload-main .obp-upload-icon { width:56px !important; height:56px !important; font-size:22px !important; margin-bottom:12px !important; }

    .obp-upload-label {
      font-size:13px !important; font-weight:600 !important; color:#475569 !important;
      font-family:'Inter',sans-serif !important; text-align:center !important;
    }
    .obp-upload-main .obp-upload-label { font-size:14px !important; }
    .obp-upload-hint {
      font-size:11px !important; color:#94a3b8 !important;
      font-family:'Inter',sans-serif !important; margin-top:4px !important;
    }

    .obp-upload-img {
      width:100% !important; height:100% !important;
      object-fit:cover !important; display:block !important;
    }

    .obp-info-text {
      font-size:13.5px !important; color:#475569 !important;
      font-family:'Inter',sans-serif !important; line-height:1.6 !important;
      margin-bottom:18px !important;
    }

    /* ── Continue button — Step4 se exact same ── */
    .obp-btn-continue {
      display:inline-flex !important; align-items:center !important; gap:8px !important;
      background:linear-gradient(135deg,#c0001a,#8b0000) !important;
      color:#fff !important; border:none !important; border-radius:10px !important;
      padding:12px 28px !important; font-size:14px !important; font-weight:700 !important;
      font-family:'Inter',sans-serif !important; cursor:pointer !important;
      letter-spacing:.02em !important; box-shadow:0 3px 14px rgba(192,0,26,.35) !important;
      transition:transform .18s,box-shadow .18s !important;
    }
    .obp-btn-continue:hover  { transform:translateY(-1px) !important; box-shadow:0 5px 20px rgba(192,0,26,.48) !important; }
    .obp-btn-continue:active { transform:scale(.97) !important; }

    /* ── Back button — Step4 se exact same ── */
    .obp-btn-back {
      display:inline-flex !important; align-items:center !important; gap:7px !important;
      border:1.5px solid #d0cbc3 !important; background:transparent !important; color:#374151 !important;
      border-radius:10px !important; padding:11px 22px !important;
      font-size:14px !important; font-weight:600 !important;
      font-family:'Inter',sans-serif !important; cursor:pointer !important;
      transition:border-color .15s,background .15s !important;
    }
    .obp-btn-back:hover { border-color:#94a3b8 !important; }

    .obp-err { font-size:12px !important; color:#dc2626 !important; margin-top:8px !important; font-family:'Inter',sans-serif !important; }

    /* ── Mobile: compact, exact-anchor-aligned, overlap-safe bot popup ── */
    @media (max-width: 767px) {
      .obp-wrap        { max-width:calc(100vw - 24px); }
      .obp-card-popup  { border-radius:10px; }
      .obp-hd          { padding:7px 8px 6px; gap:6px; }
      .obp-av svg      { width:34px !important; height:34px !important; }
      .obp-bars        { padding:1px 2px; bottom:-2px; right:-2px; }
      .obp-b           { width:1.5px; }
      .obp-name        { font-size:9px; letter-spacing:.03em; }
      .obp-sub         { font-size:7.5px; }
      .obp-dot         { width:4px; height:4px; }
      .obp-badge       { font-size:8px; padding:1px 5px; }
      .obp-tag         { padding:3px 8px; }
      .obp-tag-dot     { width:4px; height:4px; }
      .obp-tag-txt     { font-size:7.5px; }
      .obp-body        { padding:6px 8px 5px; }
      .obp-msg         { font-size:11px; line-height:1.4; }
      .obp-ft          { padding:5px 8px 7px; }
      .obp-skip-bot    { font-size:9px; padding:2px 4px; }
      .obp-next        { font-size:10px; padding:5px 10px; }
      .obp-d           { width:4px; height:4px; }
      .obp-d.on        { width:12px; }
    }
  `;
  document.head.appendChild(s);
};

/* ═══════════════════════════════════════════════════
   BOT FACE SVG — Step4 se exact same
═══════════════════════════════════════════════════ */
const BotFaceSVG: React.FC = () => (
  <svg width="64" height="64" viewBox="0 0 72 72" fill="none" style={{ overflow: "visible" }}>
    <defs>
      <style>{`
        .ob-bot-bob { animation: botBobSvg 3s ease-in-out infinite; }
        .ob-hl1 { animation: floatHeartL1 2s 0.0s  ease-out infinite; transform-origin: 23px 27px; }
        .ob-hl2 { animation: floatHeartL2 2s 0.65s ease-out infinite; transform-origin: 23px 27px; }
        .ob-hl3 { animation: floatHeartL3 2s 1.3s  ease-out infinite; transform-origin: 23px 27px; }
        .ob-hr1 { animation: floatHeartR1 2s 0.2s  ease-out infinite; transform-origin: 49px 27px; }
        .ob-hr2 { animation: floatHeartR2 2s 0.85s ease-out infinite; transform-origin: 49px 27px; }
        .ob-hr3 { animation: floatHeartR3 2s 1.5s  ease-out infinite; transform-origin: 49px 27px; }
      `}</style>
    </defs>
    <g className="ob-bot-bob">
      <line x1="36" y1="10" x2="36" y2="3" stroke="rgba(255,255,255,0.82)" strokeWidth="2.5" strokeLinecap="round" />
      <circle cx="36" cy="2" r="3.2" fill="rgba(255,255,255,0.9)" />
      <rect x="7" y="10" width="58" height="46" rx="15" fill="rgba(255,255,255,0.97)" />
      <circle cx="7"  cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <circle cx="65" cy="32" r="5.5" fill="rgba(255,255,255,0.85)" stroke="rgba(192,0,26,0.45)" strokeWidth="1.2" />
      <rect x="11" y="17" width="24" height="20" rx="9" fill="#c0001a" />
      <rect x="37" y="17" width="24" height="20" rx="9" fill="#8b0000" />
      <ellipse cx="23" cy="27" rx="9" ry="8" fill="white" />
      <ellipse cx="49" cy="27" rx="9" ry="8" fill="white" />
      <g className="ob-hl1"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff3d6b" /></g>
      <g className="ob-hl2"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob-hl3"><path d="M23,33 C23,33 12,23 12,17 C12,13 17,11 23,17 C29,11 34,13 34,17 C34,23 23,33 23,33Z" fill="#ff7099" /></g>
      <g className="ob-hr1"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff3d6b" /></g>
      <g className="ob-hr2"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#c0001a" opacity="0.88" /></g>
      <g className="ob-hr3"><path d="M49,33 C49,33 38,23 38,17 C38,13 43,11 49,17 C55,11 60,13 60,17 C60,23 49,33 49,33Z" fill="#ff7099" /></g>
      <path d="M16,46 Q36,60 56,46" stroke="#c0001a" strokeWidth="2.8" strokeLinecap="round" fill="none" />
      <ellipse cx="12" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <ellipse cx="60" cy="44" rx="6" ry="4" fill="rgba(255,100,100,0.2)" />
      <line x1="7"  y1="28" x2="2"  y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="7"  y1="36" x2="2"  y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="28" x2="70" y2="23" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
      <line x1="65" y1="36" x2="70" y2="39" stroke="rgba(255,255,255,0.78)" strokeWidth="2.4" strokeLinecap="round" />
    </g>
  </svg>
);

/* ═══════════════════════════════════════════════════
   TYPES
═══════════════════════════════════════════════════ */
type BotSide = "below" | "above" | "toright" | "toleft";
interface StepData { tag: string; plain: string; html: React.ReactNode; sideLg: BotSide; }

// Shared sizing constants — used by BotPopup for its own box AND by the main
// component to size the spacer that pushes page content down so the popup
// never overlaps the next block. Kept small so the bot stays compact and
// hugs the exact anchor field on mobile.
const GAP = 8;
const POPUP_W_MOBILE = 230, POPUP_W_DESKTOP = 310;
const POPUP_H_MOBILE = 130, POPUP_H_DESKTOP = 240;

/* ═══════════════════════════════════════════════════
   BOT STEPS DATA
═══════════════════════════════════════════════════ */
// sideLg is always "below" now — the popup is forced to appear under its anchor
// on every screen size, so this field is kept only to satisfy the StepData type.
const BOT_STEPS: StepData[] = [
  {
    tag:    "STEP 1 OF 3 — MAIN PHOTO",
    plain:  "Add your main profile photo first — tap the large box on the left!",
    html:   <>📸 <strong>Add your main profile photo</strong> first — tap the large box on the left!</>,
    sideLg: "below",
  },
  {
    tag:    "STEP 2 OF 3 — MORE PHOTOS",
    plain:  "Add up to 4 more photos — profiles with more photos get matches faster!",
    html:   <>✨ Add up to <strong>4 more photos</strong> — profiles with more photos get matches faster!</>,
    sideLg: "below",
  },
  {
    tag:    "STEP 3 OF 3 — FINISH UP",
    plain:  "Looking great! Tap Continue to complete your profile.",
    html:   <>🎉 Looking great! Tap <strong>Continue</strong> to complete your profile.</>,
    sideLg: "below",
  },
];

const TOTAL_BOT = BOT_STEPS.length;

/* ═══════════════════════════════════════════════════
   BOT POPUP — Step4 se exact same logic
═══════════════════════════════════════════════════ */
interface PopupProps {
  anchorRef: React.RefObject<HTMLDivElement | null>;
  step:      number;
  total:     number;
  data:      StepData;
  onSkip:    () => void;
  onNext:    () => void;
  nextLabel: string;
}

const BotPopup: React.FC<PopupProps> = ({ anchorRef, step, total, data, onSkip, onNext, nextLabel }) => {
  // Mobile gets a smaller card so it never overlaps content or screen edges.
  const isMobileScreen = typeof window !== "undefined" && window.innerWidth < 768;
  const PW      = isMobileScreen ? POPUP_W_MOBILE : POPUP_W_DESKTOP;
  const POPUP_H = isMobileScreen ? POPUP_H_MOBILE : POPUP_H_DESKTOP;

  const [pos,        setPos]        = useState<{ top:number; left:number; width:number } | null>(null);
  const [activeSide, setActiveSide] = useState<BotSide>("below");
  const [displayed,  setDisplayed]  = useState("");
  const [done,       setDone]       = useState(false);
  const [status,     setStatus]     = useState("typing...");
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const retryRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const calcPos = useCallback((): boolean => {
    if (!anchorRef.current) return false;
    const r  = anchorRef.current.getBoundingClientRect();
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    if (r.width === 0 && r.height === 0) return false;

    // Popup always appears BELOW the anchor — never above, never to the side.
    // It hugs the anchor's own left edge (not screen-center) so it visually
    // sits directly under the block it refers to.
    if (vw < 768) {
      const popW = Math.min(vw - 16, PW);
      const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));
      let left = r.left;
      left = Math.max(8, Math.min(left, vw - popW - 8));
      setActiveSide("below");
      setPos({ top, left, width: popW });
      return true;
    }

    let left = r.left;
    if (left + PW > vw - 8) left = vw - PW - 8;
    left = Math.max(12, Math.min(left, vw - PW - 12));

    const top = Math.max(8, Math.min(r.bottom + GAP, vh - POPUP_H - 8));

    setActiveSide("below");
    setPos({ top, left, width: PW });
    return true;
  }, [anchorRef]);

  /* Retry until anchor visible — Step4 identical */
  useEffect(() => {
    let attempts = 0; const MAX = 50;
    if (retryRef.current) clearTimeout(retryRef.current);
    setPos(null);
    const tryCalc = () => {
      const ok = calcPos();
      if (!ok && attempts < MAX) { attempts++; retryRef.current = setTimeout(tryCalc, 80); }
    };
    tryCalc();
    window.addEventListener("resize", calcPos);
    window.addEventListener("scroll", calcPos, true);
    return () => {
      if (retryRef.current) clearTimeout(retryRef.current);
      window.removeEventListener("resize", calcPos);
      window.removeEventListener("scroll", calcPos, true);
    };
  }, [calcPos, step]);

  /* Typewriter — Step4 identical */
  useEffect(() => {
    setDisplayed(""); setDone(false); setStatus("typing...");
    let i = 0;
    const tick = () => {
      if (i <= data.plain.length) { setDisplayed(data.plain.slice(0, i)); i++; timerRef.current = setTimeout(tick, 21); }
      else { setDone(true); setStatus("Online — here to guide you!"); }
    };
    tick();
    return () => { if (timerRef.current) clearTimeout(timerRef.current); };
  }, [data.plain, step]);

  if (!pos) return null;
  const isSide = activeSide === "toright" || activeSide === "toleft";

  return (
    <div className={`obp-wrap ${activeSide}`} style={{ top: pos.top, left: pos.left, width: pos.width, transform: isSide ? "translateY(-50%)" : "none" }}>
      <div className="obp-card-popup" style={{ width: "100%" }}>

        {/* Header */}
        <div className="obp-hd">
          <div className="obp-av">
            <BotFaceSVG />
            <div className="obp-bars"><div className="obp-b"/><div className="obp-b"/><div className="obp-b"/><div className="obp-b"/></div>
          </div>
          <div className="obp-meta">
            <div className="obp-name">SLAMMMM GUIDE</div>
            <div className="obp-sub"><div className="obp-dot"/><span>{status}</span></div>
          </div>
          <div className="obp-badge">{step}/{total}</div>
        </div>

        {/* Tag */}
        <div className="obp-tag"><div className="obp-tag-dot"/><div className="obp-tag-txt">{data.tag}</div></div>

        {/* Message */}
        <div className="obp-body">
          {done
            ? <p className="obp-msg">{data.html}</p>
            : <p className="obp-msg">{displayed}<span className="obp-cur"/></p>
          }
        </div>

        {/* Footer */}
        <div className="obp-ft">
          <div className="obp-dots">
            {Array.from({ length: total }).map((_, i) => (
              <div key={i} className={`obp-d${i + 1 === step ? " on" : ""}`}/>
            ))}
          </div>
          <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
            <button className="obp-skip-bot" onClick={onSkip}>Skip guide</button>
            <button
              className="obp-next"
              onClick={onNext}
              onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.transform = "translateY(-1px)"; }}
              onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.transform = "none"; }}
            >{nextLabel}</button>
          </div>
        </div>

      </div>
    </div>
  );
};

/* ═══════════════════════════════════════════════════
   PHOTO UPLOAD STEP — MAIN COMPONENT
═══════════════════════════════════════════════════ */
const PhotoUploadStep = () => {
  const {
    uploadedFiles, handleFileUpload,
    prevStep, nextStep,
    submitAnswers, uploadProgress,
  } = useOnboardingStore();
  const { setEmail, setPassword, login } = useAuthStore();
  const signIn   = useSignIn();
  const navigate = useNavigate();

  const MAX_FILES     = 5;
  const MAX_FILE_SIZE = 5 * 1024 * 1024;

  const [tempImage,   setTempImage]   = useState<string | null>(null);
  const [activeIndex, setActiveIndex] = useState<number | null>(null);
  const [showCropper, setShowCropper] = useState(false);
  const [error,       setError]       = useState<string>("");

  const mainfileInputRef = useRef<HTMLInputElement>(null);
  const fileInputRefs    = useRef<HTMLInputElement[]>([]);

  /* ── Bot ── */
  const [botStep, setBotStep] = useState<number | null>(null);
  const refMain     = useRef<HTMLDivElement>(null);
  const refExtra    = useRef<HTMLDivElement>(null);
  const refContinue = useRef<HTMLDivElement>(null);

  /* Track viewport width so the spacer (which pushes content down while the
     bot is showing) matches the popup's actual mobile/desktop size. */
  const [viewportW, setViewportW] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);
  useEffect(() => {
    const onResize = () => setViewportW(window.innerWidth);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  const spacerH = (viewportW < 768 ? POPUP_H_MOBILE : POPUP_H_DESKTOP) + GAP + 8;

  /* Renders an invisible spacer right after a bot-guide anchor. This pushes
     the next block down in normal document flow so the fixed-position bot
     popup (which floats below the anchor) never overlaps/hides it. */
  const BotSpacer = ({ n }: { n: number }) => (
    <div style={{ height: botStep === n ? spacerH : 0, transition: "height .2s ease" }} />
  );

  const getBotRef = (n: number): React.RefObject<HTMLDivElement | null> => {
    if (n === 1) return refMain;
    if (n === 2) return refExtra;
    return refContinue;
  };

  useEffect(() => {
    injectStyles();
    fileInputRefs.current = Array(MAX_FILES - 1).fill(null).map(
      (_, i) => fileInputRefs.current[i] || React.createRef<HTMLInputElement>().current
    );
    if (!localStorage.getItem("photoBotSeen")) {
      localStorage.setItem("photoBotSeen", "1");
      setTimeout(() => setBotStep(1), 400);
    }
  }, []);

  /* Scroll anchor into view — Step4 identical */
  useEffect(() => {
    if (botStep === null) return;
    getBotRef(botStep)?.current?.scrollIntoView({ behavior: "smooth", block: "center" });
  }, [botStep]);

  const nextBot = useCallback(() => setBotStep(p => p !== null && p < TOTAL_BOT ? p + 1 : null), []);
  const skipBot = useCallback(() => setBotStep(null), []);

  /* ── File handling ── */
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, index: number) => {
    if (!event.target.files || event.target.files.length === 0) return;
    const file = event.target.files[0];
    if (!file.type.startsWith("image/")) { setError("Only image files are allowed."); return; }
    if (file.size > MAX_FILE_SIZE)        { setError("File size must be less than 5MB."); return; }
    setTempImage(URL.createObjectURL(file));
    setActiveIndex(index);
    setShowCropper(true);
  };

  const handleCroppedImage = (croppedFile: File) => {
    if (activeIndex === null) return;
    const newFiles = [...uploadedFiles];
    newFiles[activeIndex] = croppedFile;
    handleFileUpload(newFiles);
    setTempImage(null); setActiveIndex(null); setShowCropper(false);
    /* Auto-advance bot when main photo uploaded */
    if (activeIndex === 0 && botStep === 1) setBotStep(2);
  };

  const handleContinue = async (e: React.MouseEvent) => {
    e.preventDefault();
    if (!uploadedFiles[0]) { setError("Main profile photo is required."); return; }
    setError("");
    const credentials = await submitAnswers();
    if (!credentials) return;
    try {
      setEmail(credentials.email);
      setPassword(credentials.password);
      const res = await login();
      if (res?.data?.token) {
        const ok = signIn({ auth: { token: res.data.token, type: "Bearer" }, refresh: res.data.refreshToken, userState: res.data.authUserState });
        if (ok) { nextStep(); navigate("/dashboard", { replace: true }); }
        else { console.error("signIn failed"); }
      } else { console.error("Auto-login failed: No token received"); }
    } catch (err) { console.error("Login failed:", err); }
  };

  return (
    <>
      {/* ── Bot popup — no overlay, same as Step4 ── */}
      {botStep !== null && botStep >= 1 && botStep <= TOTAL_BOT && (
        <BotPopup
          anchorRef={getBotRef(botStep)}
          step={botStep}
          total={TOTAL_BOT}
          data={BOT_STEPS[botStep - 1]}
          onSkip={skipBot}
          onNext={botStep < TOTAL_BOT ? nextBot : skipBot}
          nextLabel={botStep < TOTAL_BOT ? "Next →" : "Done ✓"}
        />
      )}

      {/* ── Navbar — Step4 se exact same ── */}
      <nav className="navbar navbar-expand-lg navbar-light bg-primary">
        <div className="container justify-content-center">
          <Link className="navbar-brand" to="/"><img src={logo} alt="Slammm" className="img-fluid"/></Link>
        </div>
      </nav>

      {/* ── Main section — background #f8f5f0 same as Step4 ── */}
      <section className="obp-section onboarding_main_wraper py-60">
        <div className="container">
          <div className="row">
            <div className="col-xl-8 col-lg-10 offset-xl-2 offset-lg-1">

              {/* ── Progress header — Step4 style ── */}
              <div className="onboarding_step_top_wraper mb-4">
                <h2 className="mb-1" style={{ fontFamily: "'Inter',sans-serif", fontWeight: 800, letterSpacing: "-.02em" }}>
                  Photos for your profile
                </h2>
                <p style={{ color: "#94a3b8", fontSize: 13, fontFamily: "'Inter',sans-serif", marginBottom: 10 }}>
                  Question 6/6
                </p>
                <div className="obp-prog-wrap">
                  <div className="obp-prog-bar done" />
                  <div className="obp-prog-bar done" />
                  <div className="obp-prog-bar done" />
                  <div className="obp-prog-bar done" />
                  <div className="obp-prog-bar done" />
                  <div className="obp-prog-bar active" />
                </div>
                <div className="obp-almost">
                  <div className="obp-almost-icon">🏁</div>
                  One last step — you're almost there!
                </div>
              </div>

              <form
                className="onboarding_form"
                onSubmit={e => e.preventDefault()}
                onKeyDown={e => { if (e.key === "Enter") e.preventDefault(); }}
              >
                <p className="obp-info-text">
                  Profiles with more photos have a higher chance of getting a quick match. Add your best shots!
                </p>

                <div className="row g-4">

                  {/* ── Main photo box — Bot Step 1 anchor ── */}
                  <div className="col-md-6">
                    <div ref={refMain} className="obp-photo-card">
                      <label className={`obp-upload-main${uploadedFiles[0] ? " has-image" : ""}`} style={{ cursor: "pointer" }}>
                        {uploadedFiles[0] ? (
                          <img
                            src={URL.createObjectURL(uploadedFiles[0])}
                            alt="Main photo"
                            className="obp-upload-img"
                          />
                        ) : (
                          <>
                            <div className="obp-upload-icon">
                              <i className="fa-solid fa-plus"/>
                            </div>
                            <span className="obp-upload-label">Add main photo</span>
                            <span className="obp-upload-hint">389 × 438 — tap to upload</span>
                          </>
                        )}
                        <input
                          type="file"
                          style={{ display: "none" }}
                          ref={mainfileInputRef}
                          onChange={e => handleChange(e, 0)}
                          accept="image/*"
                        />
                      </label>
                    </div>
                    <BotSpacer n={1} />
                  </div>

                  {/* ── Extra photos — Bot Step 2 anchor ── */}
                  <div className="col-md-6">
                    <div ref={refExtra} className="obp-photo-card">
                      <div className="row g-3">
                        {[...Array(MAX_FILES - 1)].map((_, index) => (
                          <div key={index} className="col-6">
                            <label className={`obp-upload-sm${uploadedFiles[index + 1] ? " has-image" : ""}`} style={{ cursor: "pointer" }}>
                              {uploadedFiles[index + 1] ? (
                                <img
                                  src={URL.createObjectURL(uploadedFiles[index + 1])}
                                  alt={`Photo ${index + 2}`}
                                  className="obp-upload-img"
                                />
                              ) : (
                                <>
                                  <div className="obp-upload-icon">
                                    <i className="fa-solid fa-plus"/>
                                  </div>
                                  <span className="obp-upload-label">Add photo</span>
                                </>
                              )}
                              <input
                                type="file"
                                style={{ display: "none" }}
                                ref={el => { fileInputRefs.current[index] = el!; }}
                                onChange={e => handleChange(e, index + 1)}
                                accept="image/*"
                              />
                            </label>
                          </div>
                        ))}
                      </div>
                    </div>
                    <BotSpacer n={2} />
                  </div>

                </div>

                {error && <p className="obp-err">{error}</p>}

                {/* ── Cropper modal ── */}
                {showCropper && tempImage && (
                  <CropperModal
                    show={showCropper}
                    imageUrl={tempImage}
                    aspectRatio={activeIndex === 0 ? 389 / 438 : 0}
                    outputSize={activeIndex === 0 ? { width: 389, height: 438 } : { width: -1, height: -1 }}
                    onCancel={() => {
                      setShowCropper(false); setTempImage(null);
                      if (mainfileInputRef.current) mainfileInputRef.current.value = "";
                      if (activeIndex && activeIndex > 0 && fileInputRefs.current[activeIndex - 1])
                        fileInputRefs.current[activeIndex - 1].value = "";
                    }}
                    onCrop={handleCroppedImage}
                  />
                )}

                {/* ── Upload progress backdrop ── */}
                <Backdrop
                  sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                  open={uploadProgress > 0}
                >
                  {uploadProgress > 0 ? (
                    <div className="progressdiv">
                      <CircularProgressbar
                        background
                        styles={buildStyles({
                          pathColor: "#c0001a",
                          textColor: "#c0001a",
                          backgroundColor: "#fff",
                        })}
                        strokeWidth={8}
                        value={uploadProgress}
                        text={`${uploadProgress}%`}
                      />
                      <h3>&nbsp; Please wait..</h3>
                    </div>
                  ) : (
                    <CircularProgress color="inherit"/>
                  )}
                </Backdrop>

                {/* ── Footer buttons — Bot Step 3 anchor, Step4 style ── */}
                <div className="d-flex justify-content-between mt-4">
                  <button type="button" className="obp-btn-back" onClick={prevStep}>
                    <i className="fa-solid fa-arrow-left" style={{ fontSize: 12 }}/> Back
                  </button>
                  <div ref={refContinue}>
                    <button type="button" className="obp-btn-continue" onClick={handleContinue}>
                      Continue <i className="fa-solid fa-arrow-right" style={{ fontSize: 12 }}/>
                    </button>
                  </div>
                </div>
                <BotSpacer n={3} />

              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PhotoUploadStep;